export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-accent-500/6 via-primary-500/5 to-secondary-500/6 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              联系我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们 · 剧集推荐与反馈</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5 max-w-lg">
              有想看的电视剧找不到？有好的追剧建议？欢迎联系被窝网电影团队。我们持续更新片源库，尽全力满足每一位剧迷的追剧需求。同时也欢迎优质内容合作方与我们取得联系。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap">
                <i className="ri-mail-line"></i>
                剧集推荐投稿
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-200/60 text-foreground-700 text-sm font-medium cursor-pointer hover:bg-background-300/60 transition-colors whitespace-nowrap">
                <i className="ri-phone-line"></i>
                商务合作咨询
              </span>
            </div>
          </div>
          <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-50 border border-background-200/60 flex items-center justify-center">
            <div className="text-center">
              <i className="ri-customer-service-2-line text-5xl text-primary-500"></i>
              <p className="text-xs text-foreground-400 mt-3">7×24小时在线</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}